document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.accordion-block__item');

  accordionItems.forEach((item) => {
    const heading = item.querySelector('.accordion-block__heading');
    const content = item.querySelector('.accordion-block__content');

    if (!heading || !content) return;

    content.style.display = 'none';

    heading.addEventListener('click', function () {
      const isOpen = item.classList.contains('active');

      accordionItems.forEach((innerItem) => {
        const innerContent = innerItem.querySelector('.accordion-block__content');
        if (innerContent) innerContent.style.display = 'none';
        innerItem.classList.remove('active');
      });

      if (!isOpen) {
        content.style.display = 'block';
        item.classList.add('active');
      }
    });
  });
});
